export type TransferForBalanceImpact = {
  status: "pending" | "completed" | "accepted" | "rejected" | "cancelled";
  amount: string;
};

const toCents = (amount: string) => {
  if (!/^-?\d+(\.\d+)?$/.test(amount)) return 0;
  return Math.round(Number.parseFloat(amount) * 100);
};

const fromCents = (cents: number) => cents / 100;

export const countsTowardBalanceAfter = (status: TransferForBalanceImpact["status"]) =>
  status === "pending" || status === "accepted";

export const balanceAfterPendingTransfers = (
  realBalance: number,
  requests: TransferForBalanceImpact[],
) => {
  const pendingCents = requests.reduce((sum, request) => {
    if (!countsTowardBalanceAfter(request.status)) return sum;
    return sum + toCents(request.amount);
  }, 0);
  return fromCents(Math.round(realBalance * 100) - pendingCents);
};

/** Booked balance after this pending request alone. Other requests are not included. */
export const transferBalanceImpact = (realBalance: number, request: TransferForBalanceImpact) => {
  if (request.status !== "pending") return undefined;
  const realCents = Math.round(realBalance * 100);
  return {
    before: fromCents(realCents),
    after: fromCents(realCents - toCents(request.amount)),
  };
};
